<template>
  <FullscreenModal :show="show" @close="show = false">
    <div class="container">
      <div class="row">
        <span class="h3">Do you need support? Ask us.</span>
        <span
          >Your question will be followed up by a real person, in the Services
          and Tools team.</span
        >
      </div>

      <div class="row pt-3">
        <form @submit="onSubmit" class="w-100">
          <div class="form-group">
            <label for="name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              name="name"
              v-model="name"
              required
            />
          </div>

          <div class="form-group">
            <label for="company">Company</label>
            <input
              type="text"
              class="form-control"
              id="company"
              name="company"
              v-model="company"
              required
            />
          </div>

          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              name="email"
              v-model="email"
              required
            />
          </div>

          <div class="form-group">
            <label for="question">Question</label>
            <textarea
              class="form-control"
              id="question"
              name="question"
              v-model="question"
              rows="5"
              required
            />
          </div>

          <div class="form-group" v-if="!isLoggedIn">
            <div class="g-recaptcha" :data-sitekey="recaptchaSiteKey"></div>
            <span v-if="recaptchaError" class="text-danger">{{
              recaptchaError
            }}</span>
          </div>

          <div>
            <a
              href="https://www.signify.com/global/privacy/legal-information/privacy-notice"
              target="_blank"
            >
              Privacy notice
            </a>
          </div>
          <div class="btn-right">
            <button type="submit" class="btn btn-secondary">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </FullscreenModal>
</template>

<script>
import { http } from "@/services/http";
import { mapGetters } from "vuex";
import settings from "@/service/Settings";

export default {
  name: "ContactUsModal",
  data() {
    return {
      show: true,
      name: "",
      company: "",
      email: "",
      question: "",
      recaptchaError: null
    };
  },
  computed: {
    recaptchaSiteKey() {
      return settings.RECAPTCHA_SITE_KEY;
    },
    ...mapGetters("brain/auth", ["isLoggedIn"])
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.recaptchaError = null;

      let token;
      if (!this.isLoggedIn) {
        // eslint-disable-next-line no-undef
        token = grecaptcha.getResponse();
        if (!token) {
          this.recaptchaError = "Please solve the reCAPTCHA challenge.";
          return;
        }
      }

      http
        .post(`/api/v2/contact`, {
          name: this.name,
          company: this.company,
          email: this.email,
          question: this.question,
          token: token
        })
        .then(() => {
          this.show = false;
          this.$snotify.success("Contact form sent successfully");
        })
        .catch(() => {
          // eslint-disable-next-line no-undef
          grecaptcha.reset();
          this.$snotify.error(
            "The contact form could not be sent. Please try again later."
          );
        });
    }
  },
  mounted() {
    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("id", "recaptcha-script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js"
    );
    document.head.appendChild(recaptchaScript);
  },
  destroyed() {
    document.getElementById("recaptcha-script").remove();
  }
};
</script>

<style scoped>
.btn-right {
  text-align: right;
}
</style>
